<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <div class="-two-columns">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Ressources</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :sorted="customOrderBy"
                            :useCustomOrderBy="customOrderBy"
                            :showDeleted="showDeleted"
                            @set-search-text="setSearchText('searchCompanyText', $event)"
                            @update-order="updateOrder"
                        >
                            <template v-slot:select-filter>
                                <Select
                                    class="q-mt-xs"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    :options="typeFilterOptions"
                                    fill-input
                                    emit-value
                                    :clearable="false"
                                    v-model="filterByType"
                                    label="Filtrer par type"
                                ></Select>
                            </template>
                            <template v-slot:custom-order-by>
                                <div class="row items-center">
                                    <q-item-section>
                                        <q-checkbox
                                            v-model="customOrderBy"
                                            label="Tri personnalisé"
                                            dense
                                            size="xs"
                                        />
                                    </q-item-section>
                                </div>
                            </template>
                        </Listbox>
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Ressources</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <div class="o-form__item full-width">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom de la ressource"
                                    label="Nom de la ressource"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Select
                                    v-model="form.type"
                                    :options="typeOptions"
                                    :clearable="true"
                                    label="Type de ressource"
                                    placeholder="Choisir type de resource"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Select
                                    v-model="form.applyTo"
                                    :options="applyToOptions"
                                    :clearable="false"
                                    required
                                    label="Attribut de ..."
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item full-width">
                                <Input
                                    type="textarea"
                                    v-model="form.description"
                                    placeholder="Description"
                                    label="Description"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <!-- <div class="o-form__item"></div> -->
                            <div class="o-form__item">
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox size="xs" dense v-model="form.ignore_tracking" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Ne pas suivre la disponibilité</q-item-label>
                                        <q-item-label caption>La ressource est toujours disponible pour une affectation et aucun conflit d'affectation
                                            ne sera rapporté.</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </div>

                            <div class="o-form__item splitter"></div>
                            <h2 class="o-form__title">Indisponibilités</h2>
                            <div class="o-form__item">
                                <DateRangesPicker
                                    v-model="addUnavailabilityDates"
                                    v-bind:selectedDates="selectedDates"
                                    :range="true"
                                    :multiple="true"
                                    :error="addUnavailabilityDatesError"
                                    @input="addUnavailabilityDatesError=false"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <q-btn-dropdown
                                    size="sm"
                                    color="white"
                                    text-color="blue"
                                    label="Ajouter une indisponibilité"
                                >
                                <q-list>
                                    <q-item clickable v-close-popup
                                        :key="'at'+at"
                                        v-for="(unavailabilityType, at) in unavailabilityTypes"
                                        @click="addUnavailability(unavailabilityType)"
                                    >
                                        <q-item-section side>
                                            <q-avatar :style="'background-color:'+unavailabilityType.color" text-color="white" size="16px" />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>
                                                {{unavailabilityType.name}}
                                            </q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                                </q-btn-dropdown>
                            </div>
                            <table class="o-form__item__table">
                                <tr
                                    :key="'al'+al"
                                    v-for="(unavailability, al) in unavailabilityDates"
                                >
                                    <td class="text-no-wrap">
                                        <q-avatar v-if="unavailability.dates[0] && unavailability.dates[0].type" class="q-mr-sm" :style="'background-color:'+unavailability.dates[0].type.color" text-color="white" size="16px" />
                                        {{ unavailability.dates[0].type.name }}
                                    </td>
                                    <td class="text-no-wrap" v-if="unavailability.dates.length==1">le {{ unavailability.dates[0].date }}</td>
                                    <td class="text-no-wrap" v-else>du {{ unavailability.dates[0].date }} au {{ unavailability.dates[unavailability.dates.length-1].date }}</td>
                                    <td class="-cell-grow">
                                        <q-icon name="cancel" color="red" class="cursor-pointer" 
                                            @click="removeUnavailability(unavailability.rangeID)"
                                        />
                                    </td>
                                </tr>
                            </table>

                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { RESOURCES, RESOURCETYPES, RESOURCESSEARCH } from '@/graphql/resource/queries'
    import { APPLYTOMODELS } from '@/graphql/tag/queries'
    import { UPSERTRESOURCE, DELETERESOURCE, RESTORERESOURCE, UPDATERESOURCECUSTOMORDER } from '@/graphql/resource/mutations'
    import { DETECTABSENCEERRORS } from '@/graphql/user/mutations'

    import { RESOURCEUNAVAILABILITYTYPES } from '@/graphql/resourceUnavailability/queries'
    // import { removeNULL } from '@/js/utilities'
    import { v4 as uuidv4 } from 'uuid';
    import {getDatesBetween} from '@/js/dateUtilities'
    import moment from 'moment';
    import _ from "lodash";
    
    export default {
        name: "Resources",
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: {},
                applyToOptions: [],
                newItem: {
                    id: 0,
                    name: null,
                    // type: "OTHER",
                    description: null,
                    tracked: false,
                    unavailabilities: [],
                },
                typeOptions: [],
                filterByType: 'ALL',
                showDeleted: false,
                perPage: 50,
                unavailabilityTypes: [],
                selectedUnavailabilityDates: [],
                addUnavailabilityDates: [],
                addUnavailabilityDatesError: false,
                customOrderBy: true,
                isReordering: false,
            }
        },
        mounted: async function(){
            this.setNewItem()
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
            typeFilterOptions() {
                let options = [
                    {
                        value: 'ALL',
                        label: 'Tous les types'
                    },
                    ...this.typeOptions
                ];

                return options;
            },

            selectedDates() {
                if (!this.addUnavailabilityDates) return new Array();

                let dates = Object.assign([], this.addUnavailabilityDates)
                dates.forEach(function (date, index) {
                    if (date.from && date.from == date.to) dates[index] = date.from;
                })
                // this.setShiftDates(dates);
                return dates.sort(function (a, b) {
                    let aDate = a, bDate = b;
                    if (a.from) {
                        aDate = a.from
                    }
                    if (b.from) {
                        bDate = b.from
                    }
                    return new Date(aDate) - new Date(bDate)
                })
            },

            unavailabilityDates(){
                if(!this.form.unavailabilities) return [];

                let unavailabilityDates=[];
                unavailabilityDates=_.chain(this.form.unavailabilities)
                                .groupBy('rangeID')
                                .map((dates, rangeID) => ({ dates, rangeID }))
                                .value();
                return unavailabilityDates;
            },
        },
        methods: {

            updateOrder(item){
                console.log(item.id, item.index);
                this.isReordering = true;
                this.$apollo.mutate({
                    mutation: UPDATERESOURCECUSTOMORDER,
                    variables: {
                        id: item.id,
                        index: item.index
                    },
                    update: () => {
                        if (this.$apollo.queries.resources) this.$apollo.queries.resources.refetch()
                    }
                })
            },

            removeUnavailability(rangeID){
                if(!this.form.deleteUnavailabilities) this.form.deleteUnavailabilities=[];

                this.form.unavailabilities.forEach(function(item){
                    if(item.rangeID==rangeID) this.form.deleteUnavailabilities.push(item.id);
                }.bind(this))
                this.form.unavailabilities=this.form.unavailabilities.filter(item => item.rangeID !== rangeID);
            },
            addUnavailability(unavailabilityType){
                if(!this.addUnavailabilityDates) return this.addUnavailabilityDatesError=true;
                this.addUnavailabilityDates.forEach(function(date){
                    let rangeID='rg-' + uuidv4();

                    if(!date.from){
                        let unavailability={
                            id: 'un-' + uuidv4(),
                            resourceUnavailabilityTypeID: unavailabilityType.id,
                            date: date,
                            rangeID: rangeID,
                            type: unavailabilityType
                        }
                        this.form.unavailabilities.push(unavailability);
                    }else{
                        let dates=getDatesBetween(date.from, date.to);

                        dates.forEach(function(dater){
                            let unavailability={
                                id: 'un-' + uuidv4(),
                                resourceUnavailabilityTypeID: unavailabilityType.id,
                                date: moment(dater).format('YYYY-MM-DD'),
                                rangeID: rangeID,
                                type: unavailabilityType
                            }
                            this.form.unavailabilities.push(unavailability);
                        }.bind(this))
                    }
                }.bind(this))
                this.addUnavailabilityDates=null;
            },

            setSearchText(prop, searchText) {
                this.setSelected(this.newItem);
                if (searchText && searchText.length > 1) searchText = searchText.trim().split(" ").join("* ") + "*";
                this.fetchSearchText(searchText);
            },

            async fetchSearchText(searchText) {

                if (searchText && searchText != "") {
                    // let search = searchText.trim().split(" ").join("* ") + "*";
                    let search = searchText.trim();//
                    // search = search.replace(/\*\*/g, '*');

                    // Vérifier si la query existe déjà
                    if (this.$apollo.queries.resourcesSearch) {
                        // Mettre à jour les variables et refetch
                        if (this.filterByType && this.filterByType != 'ALL') {
                            this.$apollo.queries.resourcesSearch.setVariables({
                                searchText: search,
                                first: this.perPage,
                                type: [this.filterByType]
                            });
                        } else {
                            this.$apollo.queries.resourcesSearch.setVariables({
                                searchText: search,
                                first: this.perPage
                            });
                        }
                        this.$apollo.queries.resourcesSearch.refetch();
                    } else {
                        // Ajouter la query seulement si elle n'existe pas
                        this.$apollo.addSmartQuery('resourcesSearch', {
                            query: RESOURCESSEARCH,
                            fetchPolicy: 'network-only',
                            error(error) {
                                if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                            },
                            variables() {

                                let variables = {
                                    searchText: search,
                                    first: this.perPage,
                                }
                                if(this.filterByType && this.filterByType != 'ALL'){
                                    variables.type = [this.filterByType]
                                }
                            
                                return variables;
                            },
                            update(resourcesSearch) {
                                this.listbox.listItems = Object.assign([], resourcesSearch.resourcesSearch.data)
                                return resourcesSearch;
                            },
                        })
                    }
                } else {
                    this.$apollo.queries.resources.refresh()
                }
            },


            setSelected(item){
                this.listbox.selectedItem = JSON.parse(JSON.stringify(item));
                this.form= JSON.parse(JSON.stringify(item));
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form = Object.assign({}, this.newItem);
                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETERESOURCE,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.resources) this.$apollo.queries.resources.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                // form=removeNULL(form);
                if (form.unavailabilities) {
                    form.unavailabilities.forEach(function (absence) {
                        delete absence.type;
                        delete absence.__typename;
                    }.bind(this))
                }

                if(form.type) {
                    form.typeID=form.type.id
                }else{
                    form.disconnectType=true
                }
                this.$apollo.mutate({
                    mutation: UPSERTRESOURCE,
                    variables: { ...form },
                    /*update: (store, { data: { upsertResource } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            const data = store.readQuery({ query: RESOURCES, variables: myVariables })
                            data.resources.data.push(upsertResource);
                            store.writeQuery({
                                query: RESOURCES,
                                data,
                            })
                        }
                        this.setSelected(upsertResource)
                    }*/
                }).then((data) => {
                    this.setSelected(data.data.upsertResource);
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                    this.detectUnavailabilityErrors(data.data.upsertResource.id)

                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                    if (this.$apollo.queries.resources) this.$apollo.queries.resources.refresh()
                })
            },
            detectUnavailabilityErrors(resourceID) {
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Sauvegarde du profile et détection d'erreurs d'absences en cours..." })
                this.$apollo.mutate({
                    mutation: DETECTABSENCEERRORS,
                    variables: {
                        resourceID: resourceID
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Détection d'erreurs d'absences complétée" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {

                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORERESOURCE,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreResource } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: RESOURCES })
                            data.resources.push(restoreResource);
                            store.writeQuery({
                                query: RESOURCES,
                                data,
                            })
                        }
                        this.setSelected(restoreResource)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
        },
        apollo: {
            applyToModels: {
                query: APPLYTOMODELS,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.applyToOptions=[];
                    data.__type.enumValues.forEach(function(item){
                        this.applyToOptions.push(item.name)
                    }.bind(this))
                    // return data.__type.enumValues
                }
            },
            resourceTypes: {
                query: RESOURCETYPES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.typeOptions=[];
                    data.resourceTypes.forEach(function(item){
                        item.label=item.name
                        item.value=item.id
                        this.typeOptions.push(item)
                    }.bind(this))
                }
            },
            unavailabilityTypes: {
                query: RESOURCEUNAVAILABILITYTYPES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.unavailabilityTypes=[];
                    data.resourceUnavailabilityTypes.forEach(function(item){
                        item.label=item.name
                        item.value=item.id
                        this.unavailabilityTypes.push(item)
                    }.bind(this))
                    return data.resourceUnavailabilityTypes;
                }
            },
            resources: {
                query: RESOURCES,
                fetchPolicy: 'cache-and-network',
                variables() {

                    let variables = {
                        trashed: this.trashed,
                        first: this.perPage,
                        orderBy: this.customOrderBy ? 'custom_order' : 'name',
                        orderSort: this.customOrderBy ? 'ASC' : 'ASC',
                    }
                    if(this.filterByType && this.filterByType != 'ALL'){
                        variables.type = [this.filterByType]
                    }

                    return variables;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(resources) {
                    if (this.isReordering) {
                        this.isReordering = false;
                        return;
                    }
                    let items = Object.assign([], resources.resources.data)
                    items.forEach(function(item){
                        if (item.type) {
                            item.color = item.type.color
                        }
                    }.bind(this))
                    this.listbox.listItems = items
                    return resources.resources.data;
                }
            }
        }
    }
</script>